<template>
  <div id="app">
    <div class="sign-up">
      <LogoDescription
        :data="{ title:'Sign In' , subtitle:'Use your Amejpay Account'}"
        :published="true"
      ></LogoDescription>
      <span class="text-success" v-if="registerSuccess">User Registered Successfully. Please Login now with the link provided you on your email address.</span>
      <span class="text-success" v-if="passwordSuccess">Passwrod change successfully! Please login now.</span>
      <span class="text-success" v-if="emailNewSuccess">Email verified successfully! Please login now.</span>

      <span class="text-danger" v-if="emailNewFail">Sorry! we can't verify your email, please contact our support team for further assistant.</span>
      <InputField></InputField>
    </div>
  </div>
</template>

<script>
// import { mapState,mapMutations } from 'vuex';
import LogoDescription from "../reuseable_components/LogoDescription";
import InputField from "../reuseable_components/InputField";

// const axios = require('axios');

export default {
  name: "AuthenticationForm",
  components: {
    LogoDescription: LogoDescription,
    InputField: InputField,
  },
  data(){
    return {
      registerSuccess: false,
      passwordSuccess: false,
      emailNewSuccess: false,
      emailNewFail: false,
    }
  },
  created() {
    this.registerSuccess = this.$route.query.register && this.$route.query.register == 'success' ? true : false
    this.passwordSuccess = this.$route.query.password && this.$route.query.password == 'success' ? true : false
    this.emailNewSuccess = this.$route.query.emailnew && this.$route.query.emailnew == 'success' ? true : false
    this.emailNewFail = this.$route.query.emailnew && this.$route.query.emailnew == 'fail' ? true : false
  }
};
</script>

<style scoped>
.text-success,
.text-danger{
  padding: 10px;
  text-align: center;
}

.sign-up {
  height: auto;
  width: 432px;
  margin-top: 1em;
  border: 1px solid #0000001a;
  display: grid;
  place-items: center;
  padding: 48px 0px;
}

@media screen and (max-width:446px){
  .sign-up{
    width:295px;
  }
}
</style>
